import React, { createContext, useContext, useState, useId } from 'react'

const ItemCtx = createContext(null)

export function Accordion({ children, className }) {
  return <div className={className}>{children}</div>
}

export function AccordionItem({ children }) {
  const [open, setOpen] = useState(false)
  const id = useId().replace(/:/g,'')
  return (
    <ItemCtx.Provider value={{ open, setOpen, id }}>
      <div className="border rounded-3 mb-2">{children}</div>
    </ItemCtx.Provider>
  )
}

export function AccordionTrigger({ children, className }) {
  const { open, setOpen, id } = useContext(ItemCtx)
  return (
    <button
      className={[
        'w-100 text-start bg-transparent border-0 px-3 py-3 fw-medium accordion-button',
        open ? '' : 'collapsed',
        className || ''
      ].join(' ')}
      aria-expanded={open}
      aria-controls={`acc-${id}`}
      onClick={() => setOpen(!open)}
      type="button"
    >
      {children}
    </button>
  )
}

export function AccordionContent({ children, className }) {
  const { open, id } = useContext(ItemCtx)
  return (
    <div id={`acc-${id}`} className={[(open ? '' : 'd-none'), className || '', 'px-3 pb-3'].join(' ')}>
      {children}
    </div>
  )
}